import { DEFAULT_ERROR_MESSAGE } from '../../common/constants/error';

export class GenericError extends Error {
  message: string;

  constructor(message: string = DEFAULT_ERROR_MESSAGE) {
    super(message);
    this.message = message;
  }
}
